import { render } from "./StripeProductChooser.vue?vue&type=template&id=e21281b0&scoped=true"
import script from "./StripeProductChooser.vue?vue&type=script&lang=js"
export * from "./StripeProductChooser.vue?vue&type=script&lang=js"

import "./StripeProductChooser.vue?vue&type=style&index=0&id=e21281b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e21281b0"]])

export default __exports__